import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  policyLabel: {
    opacity: 0.6,
    color: theme.colors.light_text
  },
  draftsLink: {
    display: 'block',
    padding: theme.spacing(1),
    marginLeft: theme.spacing(-1),
    borderRadius: 6,
    border: 'none',
    background: 'none',
    font: 'inherit',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.33,
    color: theme.colorPalette.orange_50,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colorPalette.orange_50_op_10
    }
  },
  tableContainer: {
    boxShadow: 'none',
    '& .MuiTableCell-root': {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    }
  }
});

export default makeStyles(styles);
